// utils.js // frequently used functions.

// Add leading zero to single digit numbers
export function padding(number) {
  return number.toString().padStart(2, "0");
}

export function makeReadable(pos, signs) {
    if (pos > 360) pos -= 360;
    if (pos < 0) pos += 360;
    const signIndex = Math.floor(pos / 30);
    const signPos = pos - signIndex * 30;
    const signDeg = Math.floor(signPos);
    const signMin = Math.floor((signPos - signDeg) * 60);
    const signSec = Math.round(((signPos - signDeg) * 60 - signMin) * 60);
    const formattedDeg = signDeg < 10 ? `0${signDeg}` : signDeg;
    const formattedMin = signMin < 10 ? `0${signMin}` : signMin;
    const formattedSec = signSec < 10 ? `0${signSec}` : signSec;
    return `${formattedDeg}°<span class="astro-font">${decodeHtml(signs[signIndex])}</span>${formattedMin}'${formattedSec}"`;
  }

  export function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}